import { useLicensesRef } from '../account/vaultSelectors';
import { LicensesForm } from './LicensesForm';
import { LicensesRefContext } from './utils';

export const LicensesFormWrapper = () => {
  const { licensesRef } = useLicensesRef();

  if (!licensesRef) return null;

  return (
    <LicensesRefContext.Provider value={licensesRef}>
      <LicensesForm />
    </LicensesRefContext.Provider>
  );
};
